module.exports = __webpack_public_path__ + "static/img/yaos_applet.16694ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yaos_applet.jpg
// module id = T1Qi
// module chunks = 1